import React from 'react';
import { Link } from 'react-router-dom';
import { FaTimes, FaUser, FaLock, FaArrowRight, FaGraduationCap } from 'react-icons/fa';
import './style.css';

const AuthModal = ({ isOpen, onClose, title, message, type = 'level-test', redirectState = null }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const getIcon = () => {
        switch (type) {
            case 'level-test':
                return <FaGraduationCap />;
            case 'demo':
                return <FaUser />;
            default:
                return <FaLock />;
        }
    };

    // Determine the correct signup route based on the action type
    const getSignupRoute = () => {
        if (type === 'level-test') {
            return { pathname: '/signup', state: { from: '/level-test', action: 'level-test' } };
        } else if (type === 'demo') {
            return { pathname: '/signup', state: { action: 'demo' } };
        }
        // Use redirectState if provided
        return { pathname: '/signup', state: redirectState || {} };
    };

    // Determine the correct login route based on the action type
    const getLoginRoute = () => {
        if (type === 'level-test') {
            return { pathname: '/login', state: { from: '/level-test', action: 'level-test' } };
        } else if (type === 'demo') {
            return { pathname: '/login', state: { action: 'demo' } };
        }
        // Use redirectState if provided
        return { pathname: '/login', state: redirectState || {} };
    };

    return (
        <div className="auth-modal-overlay" onClick={handleBackdropClick}>
            <div className="auth-modal-container">
                <div className="auth-modal-header">
                    <div className="auth-modal-icon">
                        {getIcon()}
                    </div>
                    <button className="auth-modal-close" onClick={onClose} aria-label="Close modal">
                        <FaTimes />
                    </button>
                </div>
                
                <div className="auth-modal-content">
                    <h2 className="auth-modal-title">{title}</h2>
                    <p className="auth-modal-message">{message}</p>
                    
                    <div className="auth-modal-actions">
                        <Link 
                            to={getLoginRoute().pathname}
                            state={getLoginRoute().state}
                            className="auth-modal-btn auth-modal-btn-primary"
                            onClick={onClose}
                        >
                            <FaUser />
                            Sign In
                        </Link>
                        <Link 
                            to={getSignupRoute().pathname}
                            state={getSignupRoute().state}
                            className="auth-modal-btn auth-modal-btn-secondary"
                            onClick={onClose}
                        >
                            <FaArrowRight />
                            Create Account
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthModal;